import { render, staticRenderFns } from "./ColorfulBars.vue?vue&type=template&id=3ea8ea10&"
import script from "./ColorfulBars.vue?vue&type=script&lang=js&"
export * from "./ColorfulBars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports